import React, { useState, useEffect } from "react";
import {
  FaArrowLeft,
  FaShareAlt,
  FaCoins,
  FaGift,
  FaCheckCircle,
  FaClock,
  FaBoxOpen,
  FaTimesCircle,
  FaPiggyBank,
  FaInfoCircle,
  FaChevronUp,
  FaChevronDown,
  FaExclamationTriangle,
} from "react-icons/fa";
import confetyIcon from "../images/confety.png";
import timerRFQ from "../images/timerRFQ.png";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowLeft from "../images/ArrowLeft.png";
import PhoneSpinner from '../images/PhoneSpinner.png';
import { Clock } from "lucide-react"; // or any clock icon you use
import { useNotification } from '../../context/NotificationContext';
import { motion, AnimatePresence } from "framer-motion";
import RFQItemsView from "./RFQItemsView"


export default function RFQDetails() {
  // simulate which step to show (1, 2, 3)
  const navigate = useNavigate();
  const location = useLocation();
  const source = location.state?.from || null;
  const [step, setStep] = useState();
  const [rfqData, setRfqData] = useState(null);
  const [itemsExpanded, setItemsExpanded] = useState(true);
  //const [timer, setTimer] = useState(599); // example: 9:59 mins
  const [timer, setTimer] = useState("0m 0s");
  const [waitingTime, setWaitingTime] = useState(0);

  const rfqId = location.state?.rfq_id || "";
  //console.log("RFQ ID from navigation state:", rfqId);
  /* console.log("RFQ ID from navigation state:", rfqId);
 console.log("RFQDetails - Full Navigation State:", location.state);
  console.log("From Cart?:", location.state?.fromCart);
  console.log("RFQ ID:", location.state?.rfq_id);
  console.log("Quotation ID:", location.state?.quotationId); */
  const [payNowLoading, setPayNowLoading] = useState(false);
  //console.log("RFQ ID from navigation state:", rfqId);
  // modal / payment visibility
  const [showBlastPopup, setShowBlastPopup] = useState(false); // show on step 2 initially
  const [showPaymentNeeded, setShowPaymentNeeded] = useState(false);
  const { notifications, setNotifications } = useNotification();
  const [loading, setLoading] = useState(false);
  const [waitingTimeMs, setWaitingTimeMs] = useState(0);



  const handleBack = () => {
    navigate(-1);
  };


  /*  useEffect(() => {
       if (rfqData && step === 1) {
         // Calculate remaining time based on createdAt and RFQ_waiting_time
         const totalTimeInSeconds = (rfqData.RFQ_waiting_time || 10) * 60;
         const createdTime = new Date(rfqData.createdAt).getTime();
         const now = Date.now();
         const elapsedSeconds = Math.floor((now - createdTime) / 1000);
         const remainingTime = Math.max(totalTimeInSeconds - elapsedSeconds, 0);
         setTimer(remainingTime);
       }
     }, [rfqData, step]); */

  const calculateRemainingTime = (expiryTime) => {
    if (!expiryTime) return 0;

    const expiry = new Date(expiryTime).getTime();
    const now = Date.now();
    const diff = expiry - now;

    return diff > 0 ? Math.floor(diff / 1000) : 0;
  };

  useEffect(() => {
    if (!rfqData?.payment_time_expired_at) {
      setTimer(0);
      return;
    }

    const initialSeconds = calculateRemainingTime(rfqData.payment_time_expired_at);
    setTimer(initialSeconds);

  }, [rfqData]);


  useEffect(() => {
    // load step data from sample.json
    if (rfqData && rfqData.status === 'Waiting For Best Prices') {
      setStep(1);
    } else if (rfqData && rfqData.status === 'Final Price Received') {
      //setShowBlastPopup(!rfqData.viewed_bestprice_received);
      setShowBlastPopup(rfqData.viewed_bestprice_received);
      setStep(2);
      handlePaymentTimer();
      setShowPaymentNeeded(true);
    } else if (rfqData && rfqData.status === 'Order Placed Sucessfully') {
      setStep(3);

    } else if (rfqData && rfqData.status === 'Cancelled') {
      setStep(4);
    }
  }, [rfqData]);

  //rfq waiting time handler
  useEffect(() => {
    if (!rfqData?.waiting_time_expired_at) return;

    const expiryTime = new Date(rfqData.waiting_time_expired_at).getTime();

    const interval = setInterval(() => {
      const now = Date.now();
      const diffMs = Math.max(expiryTime - now, 0);

      // Convert to minutes (ceil → so "2.4 minutes" becomes 3)
      const minutesLeft = Math.ceil(diffMs / 60000);

      // STOP updating when 2 mins remain
      if (minutesLeft <= 2) {
        setWaitingTime(2);
        clearInterval(interval);
        return;
      }

      setWaitingTime(minutesLeft);
    }, 1000);

    return () => clearInterval(interval);
  }, [rfqData]);


  const handlePaymentTimer = () => {
    if (rfqData?.payment_time_expired_at) {
      const expiry = new Date(rfqData.payment_time_expired_at).getTime();
      const now = Date.now();
      const diff = Math.max(expiry - now, 0);

      setTimer(Math.floor(diff / 1000));
    } else {
      setTimer(10 * 60); // fallback
    }
  };

  useEffect(() => {
    if (!timer) return; // if 0 or null, stop

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  //rfq waiting time countdown
  useEffect(() => {
    if (waitingTime <= 2) return;

    const interval = setInterval(() => {
      setWaitingTime((prev) => {
        if (prev <= 2) return prev;
        return prev - 1;
      });
    }, 60000);

    return () => clearInterval(interval);
  }, [waitingTime]);



  useEffect(() => {
    // Reset timer when step changes
    getCustomerRfqdetails(rfqId);
  }, [rfqId]);



  const getCustomerRfqdetails = async () => {
    try {
      // Get user info
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const userId = userData?._id;
      const token = userData?.token || sessionStorage.getItem('token');
      if (!userId) return;
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-by-id?RFQId=${rfqId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Fetched RFQ details:', data);
      setRfqData(data.data);
    } catch (error) {
      console.error('Error fetching RFQ details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (notifications && notifications.length > 0 && rfqId) {
      setLoading(true)
      getCustomerRfqdetails(rfqId);
    }
  }, [notifications, rfqId]);

  const [prevItem, setPrevItem] = useState(null)
  const [swapItem, setSwapItem] = useState(null)
  const [swapAndSavePopup, setSwapAndSavePopup] = useState(false)

  const handleSwap = (item, sug) => {
    try {
      if (!item || !sug) {
        console.error("Swap failed: Missing item or suggestion");
        return;
      }

      console.log("Swapping Item:", item, " → Suggested:", sug);

      setPrevItem(item);
      setSwapItem({ ...sug, not_available: false });
      setSwapAndSavePopup(true);

    } catch (error) {
      console.error("Error in handleSwap:", error);
    }
  };


  const handleSwapAndSaveItem = async () => {
    try {
      // Prepare ID payload
      const payload = {
        quotation_id: rfqData?.quotation_id || null,
        sales_order_id: rfqData?.order_id || null,
      };

      // Build final items array (swap only the selected one)
      const items = rfqData.items.map((item) => {
        const isSwapped = item.item_id === prevItem.item_id;
        const source = isSwapped ? swapItem : item;

        // ✔ Corrected cost price logic
        const costprice =
          source.cost_price && source.cost_price > 0
            ? source.cost_price
            : source.selling_price;

        return {
          item_id: source.item_id,
          item_name: source.item_name,
          item_image: source.item_image,  // corrected key
          not_available: source.not_available,
          UOM: source.UOM,
          UOM_id: source.UOM_id,
          vendor_id: source.vendor_id,

          cost_price: costprice,

          // ✔ Quotation uses requested_price
          requested_price:
            source.requested_price ??
            source.selling_price ??
            0,

          // ✔ Sales order uses final_price (or selling_price fallback)
          final_price:
            source.final_price ??
            source.selling_price ??
            0,

          quantity:
            item.quantity ??
            source.quantity ??
            1,

          tax_rate:
            source.tax_rate ??
            item.tax_rate ??
            18,
        };
      });

      payload.items = items;

      // console.log("Swap Payload Sent:", payload);

      // CALL API
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/update-swap-item`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      //console.log("Swap Save Response:", result);

      if (result.success) {
        setSwapAndSavePopup(false);
        getCustomerRfqdetails(rfqData._id);
      }

    } catch (error) {
      console.error("Swap error:", error);
    }
  };


  if (!rfqData) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-500">
        Loading RFQ Details...
      </div>
    );
  }

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-500">
        Loading...
      </div>
    );
  }


  // In your React component function, declare these variables before the return statement
  let discount = 0;
  let totalBonus = 0;
  let finalTotalValue = 0;

  if (rfqData) {
    /* discount = rfqData.discount || 0;
    totalBonus = rfqData.earned_build_coins || 0; */
    if (step === 1) {
      discount = rfqData.discount || 0;
      totalBonus = rfqData.earned_build_coins || 0;
      finalTotalValue = rfqData.bill_details?.estimated_total || 0;
    } else if (step === 2) {
      // For step 2, use savings_breakup
      if (rfqData.savings_breakup) {
        rfqData.savings_breakup.forEach(item => {
          if (item.type === 'discount') discount = item.amount;
          if (item.type === 'buildcoins') totalBonus = item.amount;
        });
      }
      finalTotalValue = rfqData.bill_details?.total || 0;
    } else if (step === 3) {
      // For step 3, use savings_breakup
      if (rfqData.savings_breakup) {
        rfqData.savings_breakup.forEach(item => {
          if (item.type === 'discount') discount = item.amount;
          if (item.type === 'buildcoins') totalBonus = item.amount;
        });
      }
      finalTotalValue = rfqData.bill_details?.final_bill || 0;
    }
  }

  // payment timer formatter
  const formatCountdown = (seconds) => {
    if (seconds <= 0) return "Time Completed";

    const m = Math.floor(seconds / 60);
    const s = seconds % 60;

    return `${m}m ${s}s`;
  };

  // Format waiting time in minutes
  const formatWaitingMinutes = (minutes) => {
    if (minutes <= 0) return "--";
    if (minutes === 1) return "1 min";
    return `${minutes} mins`;
  };




  const handleCloseViewBestPricePoup = async () => {
    try {
      // Close the popup

      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const userId = userData?._id;
      const token = userData?.token || sessionStorage.getItem('token');
      const UpdateData = { rfqId: rfqData._id, viewed_bestprice_received: false };
      if (!userId) return;
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/rfq-vps-status-update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
        body: JSON.stringify(UpdateData),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log('Closed best price popup:', data);

      setShowBlastPopup(false);
      setShowPaymentNeeded(true);
    } catch (error) {
      console.error('Error closing best price popup:', error);
    }
  }

  const handleNavigateToOrder = () => {
    navigate('/consumer/app/orderdetails', { state: { orderId: rfqData.order_id, quotationId: rfqData.quotation_id } });
  }

  const prevQty = prevItem?.quantity ?? 0;
  const prevPrice = prevItem?.selling_price ?? 0;
  const swapPrice = swapItem?.selling_price ?? 0;

  const savingsAmount = (prevPrice * prevQty) - (swapPrice * prevQty);


  // helpers / derived values
  const { items = [], bill_details = {}, total, total_savings, earned_build_coins = 0, status, status_message } =
    rfqData;

  const subtotal = rfqData.subtotal ?? rfqData.subtotal ?? rfqData.subtotal;
  const tax = rfqData.tax_amount ?? rfqData.tax_amount ?? Math.round(subtotal * 0.18);
  const savings = rfqData.total_savings ?? rfqData.total_savings ?? total_savings ?? 0;
  const savings_breakup = rfqData.savings_breakup ?? [];
  const finalTotal = rfqData.total ?? rfqData.total ?? rfqData.total ?? total ?? subtotal + tax - savings;
  const estimated_total = rfqData.estimated_rfq_total
  const estimatedTotal = rfqData.estimated_total ?? 0;
  //console.log("savings:", savings);
  const earnedCoins = rfqData?.earned_build_coins || 0;
  const savingsBreakup = rfqData?.savings_breakup || [];
  // render item image or placeholder
  const ItemImage = ({ src, name }) => {
    if (src) {
      return (
        <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0 flex items-center justify-center">
          <img src={src} alt={name} className="w-full h-full object-contain" />
        </div>
      );
    }
    // placeholder with icon + initials
    const initials = (name || "")
      .split(" ")
      .map((s) => s[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();
    return (
      <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <FaBoxOpen className="text-gray-400 text-xl" />
          <span className="text-xs text-gray-500 mt-1">{initials}</span>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 font-sans flex flex-col">
      {/* Header */}
      <div className="bg-white sticky top-0 z-50 h-14  border-b shadow-sm">
        <div className="max-w-md mx-auto px-1 mb-2 mt-1 flex items-center justify-between">
          <div className="flex items-center gap-1">
            <button
              onClick={handleBack}
              className="flex items-center justify-center"
            >
              <img
                src={ArrowLeft}
                alt="Back"
                className="w-12 h-8 object-contain"
              />
            </button>
            <div>
              <h1 className="text-lg font-semibold text-gray-900 ">RFQ Details</h1>
              <p className="text-xs text-gray-500">{rfqData.rfq_number ?? ""}</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button className="p-2 hover:bg-gray-100 rounded-lg transition">
              <FaShareAlt className="w-6 h-4 text-gray-700 mr-2" />
            </button>
          </div>
        </div>
      </div>

      {/* Top step-area */}
      <div className="max-w-md mx-auto px-4 mt-4">
        {step === 1 && (
          <div className="bg-white rounded-xl shadow-sm p-5 text-center border border-gray-100">
            <div className="flex flex-col items-center">
              <div className="w-28 h-28 flex items-center justify-center rounded-full mb-3">
                {/* static timer image (no rotation) */}
                <img src={timerRFQ} alt="Timer" className="w-28 h-28 object-contain" />
              </div>
              <h2 className="text-lg font-semibold text-gray-900">Fetching the Best Price</h2>
              <p className="text-sm text-gray-600 mt-2">
                We’ve sent your RFQ to verified suppliers. This usually takes around <strong className="ml-1">{formatWaitingMinutes(waitingTime)}</strong>
                .
              </p>
            </div>
          </div>
        )}


        {step === 2 && !showBlastPopup && showPaymentNeeded && (
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden w-full max-w-md mx-auto">

            {/* ⏳ Countdown Section */}
            <div className="border-b border-gray-200 text-center text-gray-700 py-3">
              <p className="text-sm font-semibold">
                Your final price expires in{" "}
                <span className="bg-red-100 text-red-600 font-bold px-2 py-0.5 rounded-full">
                  {formatCountdown(timer)}
                </span>
              </p>
            </div>

            {/* 💰 Final Price Summary Section */}
            <div className="p-5 text-center">
              <h3 className="text-base font-semibold text-gray-800 mb-2">
                Final Price Received!
              </h3>

              {/* 💵 Final Price Block */}
              <div className="flex items-center justify-center gap-2 mb-5">
                {/* Estimated (Old) Price – subtle and secondary */}
                {/*  {estimatedTotal > 0 && estimatedTotal !== finalTotal && (
    <span className="text-gray-400 line-through text-lg">
      ₹{Number(estimatedTotal).toLocaleString("en-IN")}
    </span>
  )} */}

                {savings > 0 && (
                  <span className="text-gray-400 line-through text-lg">
                    ₹{(
                      estimated_total > 0
                        ? estimated_total
                        : finalTotal + savings
                    ).toLocaleString("en-IN")}

                  </span>
                )}


                {/* Final (New) Price – bold and dominant */}
                <span className="text-2xl font-bold text-gray-900">
                  ₹{Number(finalTotal).toLocaleString("en-IN")}
                </span>
              </div>


              {/* 💸 Savings and BuildCoins */}
              {((savings > 0) || (earnedCoins > 0)) && (
                <div className={`grid  gap-4 max-w-sm mx-auto w-full ${savings > 0 && earnedCoins > 0 ? 'grid-cols-2' : 'grid-cols-1'}`}>

                  {/* 🐷 Savings Card (only show when savings > 0) */}
                  {savings > 0 && (
                    <div className="flex flex-col items-center justify-center border border-green-200 bg-green-50 rounded-xl py-4 shadow-sm w-full">
                      <div className="flex items-center gap-1">
                        {/* <FaPiggyBank className="text-green-500 text-2xl" /> */}
                        <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                          Savings
                          <FaInfoCircle className="text-gray-400 text-[12px]" />
                        </span>
                      </div>
                      <span className="text-lg font-bold text-green-700 mt-0.5">
                        ₹{Number(savings).toLocaleString("en-IN")}
                      </span>
                    </div>
                  )}

                  {/* 🪙 BuildCoins Earned (only show when earnedCoins > 0) */}
                  {earnedCoins > 0 && (
                    <div className="flex flex-col items-center justify-center border border-yellow-200 bg-yellow-50 rounded-xl py-4 shadow-sm w-full">
                      <div className="flex flex-col text-gray-600 font-medium">
                        <span className="text-sm">BuildCoins</span>

                        <span className="text-sm flex items-center gap-1">
                          Earnings
                          <FaInfoCircle className="text-gray-400 text-[12px]" />
                        </span>
                      </div>

                      <span className="flex items-center text-lg font-bold text-amber-600 mt-0.5 space-x-1">
                        {earnedCoins}
                        {/* <FaCoins className="text-yellow-500 text-2xl ml-1" /> */}
                        <img src="/static/media/buildcoin.cccd231cbfda56655d1e.png" alt="BuildCoin" class="w-7 h-6  rounded-md  ml-1"></img>
                      </span>

                    </div>
                  )}

                </div>
              )}

            </div>

            {/* 🔴 Pay Now Message */}
            <div className="text-center mb-4 px-2">
              <p className="text-sm text-gray-600">
                <button
                  onClick={() => {
                    setShowPaymentNeeded(true);
                    //setPayNowLoading(true);
                    setTimeout(() => {
                      navigate("/consumer/paymentmethod", {
                        state: {
                          rfq_id: rfqData._id,
                          quotationData: rfqData,
                          totalAmount: rfqData.total,
                          quotationId: rfqData.quotation_id,
                          quotationNumber: rfqData.quotation_number,
                        },
                      });
                    }, 10);
                  }}
                  className="text-red-500 font-semibold underline decoration-dotted hover:text-red-600 transition "
                >
                  Pay Now
                </button>{" "}
                to secure your savings and BuildCoin rewards.
              </p>
            </div>

          </div>
        )}

        {step === 3 && (
          <div className="bg-white rounded-2xl shadow-md p-6 text-center border border-gray-100 animate-fadeIn">
            <div className="flex flex-col items-center justify-center">
              <div className="relative mb-3">
                <div className="absolute inset-0 rounded-full bg-green-100 scale-125"></div>
                <FaCheckCircle className="text-green-600 text-4xl relative z-10" />
              </div>

              <h2 className="text-xl font-semibold text-gray-900">Order Confirmed!</h2>
              <p className="text-sm text-gray-600 mt-1">
                Payment received — your RFQ has been converted to order successfully.
              </p>

              <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 w-full text-sm text-gray-700">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Order Number</span>
                  <span className="font-semibold text-blue-900 underline decoration-dotted hover:underline cursor-pointer"
                    onClick={() => handleNavigateToOrder()}>
                    {rfqData?.order_number ?? "-"}
                  </span>
                </div>
                {/* Uncomment if you later add internal order IDs */}
                {/* <div className="flex items-center justify-between mt-1">
          <span className="text-gray-600">Order ID</span>
          <span className="font-medium text-gray-800">{rfqData?.order_id ?? "-"}</span>
        </div> */}
              </div>

              <p className="text-xs text-gray-500 mt-3">
                Thank you for choosing us! We’ll notify you when your items are ready to ship.
              </p>
            </div>
          </div>
        )}

        {step === 4 && (
          <div className="bg-white rounded-2xl shadow-md p-6 text-center border border-gray-100 animate-fadeIn">
            <div className="flex flex-col items-center justify-center">
              {/* Cancel Icon */}
              <div className="relative mb-3">
                <div className="absolute inset-0 rounded-full bg-red-100 scale-125"></div>
                <FaTimesCircle className="text-red-600 text-4xl relative z-10" />
              </div>

              {/* Title */}
              <h2 className="text-xl font-semibold text-gray-900">RFQ Cancelled</h2>

              {/* Subtext */}
              <p className="text-sm text-gray-600 mt-2">
                {rfqData?.status_message || "This RFQ has been cancelled."}
              </p>

              {/* Optional details box */}
              <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 w-full text-sm text-gray-700">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">RFQ Number</span>
                  <span className="font-semibold text-gray-900">
                    {rfqData?.rfq_number ?? "-"}
                  </span>
                </div>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-gray-600">Status</span>
                  <span className="font-medium text-red-600">{rfqData?.status ?? "Cancelled"}</span>
                </div>
              </div>

              {/* Footer note */}
              <p className="text-xs text-gray-500 mt-3">
                You can create a new RFQ anytime or contact support if you need help.
              </p>
            </div>
          </div>
        )}


      </div>

      {/* Items list & Bill */}
      <div className="max-w-md mx-auto mt-6 px-4 w-full flex-1">
        <div className="bg-white rounded-xl space-y-3 shadow-sm border border-gray-100 overflow-hidden">
          <button
            onClick={() => setItemsExpanded(!itemsExpanded)}
            className={`w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors ${itemsExpanded ? "border-b border-gray-200" : ""}`}
          >
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              Items Requested - {rfqData ? rfqData.total_items || "" : ""}
            </h2>

            {/* Arrow Icon for Expand/Collapse */}
            <span className="text-gray-500 text-md transition-transform duration-200">
              {itemsExpanded ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </button>


          {/*suggestedItems dont remove the code */}

          {/*  {itemsExpanded && (
  <div className="space-y-4">
    {Object.entries(
      items.reduce((acc, item) => {
        const categoryObj = rfqData.product_categories.find(
          (cat) => cat._id === item.product_category_id
        );
        const categoryName = categoryObj
          ? categoryObj.product_category_name
          : " Other Products";
        if (!acc[categoryName]) acc[categoryName] = [];
        acc[categoryName].push(item);
        return acc;
      }, {})
    ).map(([categoryName, categoryItems]) => (
      <div
        key={categoryName}
        className="bg-white rounded-sm overflow-hidden"
      >
       
        <div className="flex justify-between items-center bg-gray-50 px-4 py-2 border-b border-gray-200">
          <h3 className="text-sm font-semibold text-gray-800">{categoryName}</h3>
          <span className="text-xs text-gray-500">
            {categoryItems.length} item{categoryItems.length > 1 ? "s" : ""}
          </span>
        </div>

       
        <div className="divide-y divide-gray-100">
  {categoryItems.map((item, idx) => {
    const quantity = item.quantity ?? 1;
    const unitPrice = Number(item.selling_price ?? 0);
    const lineTotal = unitPrice * quantity ?? item.total;

    // Determine if item is not available
    const isNotAvailable = item.not_available === true;

    return (
      <div
        key={item.item_id ?? idx}
        className={`px-4 py-3 relative ${
          idx !== categoryItems.length - 1 ? "border-b border-gray-100" : ""
        }`}
      >
        
        <div className={`flex items-center justify-between relative z-0 ${isNotAvailable ? "bg-gradient-to-r from-gray-50 to-gray-100 opacity-50 rounded-md p-2" : ""}`}>
          
          <div className="flex items-start gap-3 flex-1 min-w-0">
           
            <div className="w-12 h-12 bg-gray-50 border border-gray-200 rounded-md overflow-hidden flex items-center justify-center">
              {item.item_image ? (
                <img
                  src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.item_image}`}
                  alt={item.item_name}
                  className="object-contain w-full h-full"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.parentNode.innerHTML =
                      '<span class="text-gray-400 text-[10px] text-center">No Image</span>';
                  }}
                />
              ) : (
                <span className="text-gray-400 text-[10px] text-center">No Image</span>
              )}
            </div>

            
            <div className="min-w-0">
              
              <div className="text-sm font-medium text-gray-900 line-clamp-2">
                {item.item_name}
              </div>

              
              <div className="text-[12px] text-gray-500 mt-1">
                ₹{Number(unitPrice).toLocaleString("en-IN")}
                <span className="mx-1 text-gray-400">×</span>
                {quantity} qty
              </div>

              
              {item.bonus > 0 && (
                <div className="flex items-center text-[11px] text-yellow-700 font-medium mt-1">
                  <FaCoins className="text-yellow-400 mr-1 text-xs" />
                  +{item.bonus} Coins
                </div>
              )}
            </div>
          </div>

         
<div className="flex flex-col  items-end min-w-[80px]">

  {item.requested_price && unitPrice < item.requested_price && (
    <div className="text-xs text-gray-400 line-through">
      ₹{Number(item.requested_price * quantity).toLocaleString("en-IN")}
    </div>
  )}


  <div className="text-lg font-semibold text-gray-900 tracking-tight">
    ₹{Number(lineTotal).toLocaleString("en-IN")}
  </div>

 
  {isNotAvailable && (
    <div className="text-xs font-medium text-red-600 mt-1 ">
      Out of Stock
    </div>
  )}
</div>

        </div>

        
        {item.suggested_items && item.suggested_items.length > 0 && (
          <div className="mt-3">
            <div className="text-xs text-gray-500 mb-2 font-medium flex items-center gap-1">
              <span>💡 Better options available:</span>
            </div>

            <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
              {item.suggested_items.map((sug, sIdx) => {
                const sugUnitPrice = Number(sug.selling_price ?? 0);
                const difference = sugUnitPrice - unitPrice; // Calculate difference
                const total_price = sugUnitPrice * sug.quantity || 0;
                return (
                  <div
                    key={sIdx}
                    className="min-w-[160px] max-w-[180px] border-2 border-gray-300 rounded-lg p-2 bg-gradient-to-br from-gray-50 to-white  hover:shadow-md hover:border-gray-400 transition-all duration-300 flex-shrink-0 cursor-pointer transform hover:scale-100"
                  >
                    
                    <div className="flex items-center gap-2">
                      
                      <div className="w-10 h-10  rounded-md flex items-center justify-center overflow-hidden border border-gray-200 flex-shrink-0">
                        {sug.item_image ? (
                          <img
                            src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${sug.item_image}`}
                            alt={sug.item_name}
                            className="object-contain w-full h-full"
                          />
                        ) : (
                          <span className="text-gray-400 text-[8px] text-center">No Image</span>
                        )}
                      </div>

                    
                      <div className="flex-1 min-w-0">
                     
                        <div className="text-[10px] font-medium text-gray-800 line-clamp-2 leading-tight">
                          {sug.item_name}
                        </div>

                        
                        <div className="flex items-center space-x-4 mt-1">
                          <div className="text-[10px] text-gray-800">
                            {sug.quantity} {sug.UOM && `(${sug.UOM})`}
                          </div>
                          <div className="text-xs font-bold text-green-700">
                            ₹{total_price.toLocaleString("en-IN")}
                          </div>
                        </div>

                       
                      </div>
                    </div>

                  
                    <button
                      onClick={() => handleSwap(item, sug)}
                      className="mt-2 w-full bg-gradient-to-r from-red-500 to-red-600 text-white text-[9px] py-1 rounded-md hover:from-red-600 hover:to-red-700 transition-colors duration-200 font-medium flex items-center justify-center gap-1"
                    >
                      <span>🔄</span> Swap & Save
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  })}
</div>

      </div>
    ))}

    {items.length === 0 && (
      <div className="px-4 py-6 text-center text-sm text-gray-500">
        No items in this RFQ
      </div>
    )}
  </div>
)} */}

          {itemsExpanded && (
            <>
              <RFQItemsView
                itemsExpanded={itemsExpanded}
                setItemsExpanded={setItemsExpanded}
                items={items}
                rfqData={rfqData}
                handleSwap={handleSwap}
              />
            </>
          )}

        </div>

        {/* Bill section */}
        <div className="bg-white mx-0 mt-4 mb-4 rounded-xl border border-gray-100 overflow-hidden shadow-sm">
          <div className="px-4 py-4">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-semibold text-gray-800">
                {step === 1 ? "Estimated Bill" : "Final Bill"}
              </h3>
              {/*  <div className="text-sm text-gray-500">{status}</div> */}
            </div>

            <div className="mt-3 text-sm text-gray-700 space-y-3">
              <div className="flex justify-between">
                <span>Subtotal</span>
                <span>₹{Number(subtotal).toLocaleString("en-IN")}</span>
              </div>

              {rfqData?.discount > 0 ? (
                <div className="flex justify-between text-green-700">
                  <span>{step === 1 ? "BuildCoins Discount up to" : "BuildCoins Discount"}</span>
                  <span>- ₹{Number(rfqData?.discount).toLocaleString("en-IN")}</span>
                </div>
              ) : (
                <></>
              )}

              <div className="flex justify-between">
                <span>Tax</span>
                <span>₹{Number(tax).toLocaleString("en-IN")}</span>
              </div>

              {rfqData.delivery_charges > 0 ? (
                <div className="flex justify-between">
                  <span>Delivery Charges</span>
                  <span>₹{Number(rfqData.delivery_charges).toLocaleString("en-IN")}</span>
                </div>
              ) : (
                <></>
              )}

              <hr className="border-gray-200" />

              <div className="flex justify-between items-center pt-2">
                <div>
                  <div className="text-sm text-gray-500">Total </div>

                </div>

                <div className="text-right text-sm">
                  <div className="text-lg font-semibold">
                    ₹{Number(finalTotal).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="h-28" />
      </div>


      {/* --- Footer Section (with Save & Earn Banner) --- */}
      <div className="fixed bottom-0 left-0 right-0 z-50">
        {/* Save & Earn Banner */}
        {(discount > 0 || totalBonus > 0) && (
          <div className="bg-gradient-to-r from-green-600 to-green-500 shadow-md flex flex-wrap items-center justify-center px-3 py-2 gap-2 text-white text-sm sm:text-md font-medium">
            <span className="flex flex-wrap items-center gap-1">
              {discount > 0 && (
                <>
                  <span className="font-semibold">Saved</span> up to{" "}
                  <span className="font-bold text-base flex items-center">
                    ₹{Number(discount).toLocaleString("en-IN")}
                  </span>
                </>
              )}
              {discount > 0 && totalBonus > 0 && <span>&</span>}
              {totalBonus > 0 && (
                <>
                  <span className="font-semibold">Earned</span> up to{" "}
                  <span className="font-bold text-base flex items-center">
                    {totalBonus}
                    <FaCoins className="ml-1 text-yellow-300" />
                  </span>
                </>
              )}
            </span>
          </div>
        )}


        {/* Footer Summary Bar */}
        {/* {step === 2 && (
  <div className="bg-red-50 border-l-2 border-red-500 text-red-600 px-4 py-2 flex items-start justify-center gap-2 text-sm font-medium">
    <FaExclamationTriangle className="mt-0.5 flex-shrink-0 text-red-500" />
    <p className="leading-snug">
      Delaying payment will result in losing benefits and a{" "}
      <span className="font-semibold">100 BuildCoin penalty.</span>
    </p>
  </div>
)} */}

        {step === 2 && (
          <div className="bg-amber-50 border-l-4 border-amber-400 text-amber-800 px-4 py-2 flex items-start justify-center gap-2 text-xs rounded-sm">
            <FaExclamationTriangle className="mt-0.5 flex-shrink-0 text-amber-500" />
            <p className="leading-snug font-normal">
              Late payments will be charged{" "}
              <span className="font-bold text-amber-700">100 BuildCoins.</span>
            </p>
          </div>
        )}



        <div className="bg-white border-t border-gray-200 shadow-sm sticky bottom-0 z-40">
          <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between">

            {/* Left side - total or status */}
            <div>
              {step === 1 && (
                <>
                  <div className="text-xs text-gray-500">Estimated Total</div>
                  <div className="text-lg font-semibold text-gray-900">
                    ₹{Number(finalTotal).toLocaleString("en-IN")}
                  </div>
                </>
              )}

              {step === 2 && (() => {
                const oldPrice = subtotal + tax;

                return (
                  <>
                    <div className="text-xs text-gray-500">Final Price</div>

                    <div className="flex items-center gap-2 text-lg">

                      {/* Show old price only when different */}

                      {/* Always show final price */}
                      <span className="font-semibold text-gray-900">
                        ₹{Number(finalTotal).toLocaleString("en-IN")}
                      </span>

                      {estimated_total !== finalTotal && estimated_total > finalTotal && (
                        <span className="text-gray-400 line-through text-base">
                          ₹{Number(estimated_total).toLocaleString("en-IN")}
                        </span>
                      )}


                    </div>
                  </>
                );
              })()}



              {step === 3 && (
                <>
                  <div className="text-xs text-gray-600">Order Value</div>
                  <div className="text-lg font-semibold text-gray-900">
                    ₹{Number(finalTotal).toLocaleString("en-IN")}
                  </div>
                </>
              )}

              {step === 4 && (
                <div className="text-sm font-medium text-red-700 px-4 py-2 rounded-full shadow-sm">
                  This RFQ has been cancelled. Please place a new RFQ to proceed.
                </div>
              )}
            </div>

            {/* Right side - action or message */}
            <div className="text-right">
              {step === 1 && (
                <div className="text-sm font-medium rounded-full bg-yellow-50 text-yellow-700 px-4 py-2 shadow-sm">
                  Waiting for Best Prices...
                </div>
              )}

              {step === 2 && (
                <button
                  onClick={() => {
                    setShowPaymentNeeded(true);
                    setPayNowLoading(true);
                    setTimeout(() => {
                      navigate("/consumer/paymentmethod", {
                        state: {
                          rfq_id: rfqData._id,
                          quotationData: rfqData,
                          totalAmount: rfqData.total,
                          quotationId: rfqData.quotation_id,
                          quotationNumber: rfqData.quotation_number,
                        },
                      });
                    }, 500);
                  }}
                  className="bg-red-500 hover:bg-red-600 text-white text-sm font-semibold px-5 py-2 rounded-lg shadow-md transition-all"
                >
                  {payNowLoading ? (
                    <div className="flex items-center justify-center">
                      <img
                        src={PhoneSpinner}
                        alt="Loading"
                        className="h-5 w-5 object-contain animate-spin mr-2"
                      />
                      Processing...
                    </div>
                  ) : (
                    <span>Pay Now</span>
                  )}
                </button>
              )}

              {step === 3 && (
                <div className="text-sm font-semibold text-green-600">
                  Order Number &nbsp;–&nbsp;
                  <span
                    className="text-blue-900 underline decoration-dotted hover:underline cursor-pointer"
                    onClick={() => handleNavigateToOrder()}
                  >
                    {rfqData?.order_number || "ORD-XXXX"}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>



      {showBlastPopup && step === 2 && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <AnimatePresence>
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", stiffness: 120, damping: 12 }}
              className="bg-white rounded-3xl shadow-2xl w-11/12 max-w-sm p-6 relative overflow-hidden border border-gray-100"
            >
              {/* 🌈 Soft Glow Backgrounds */}
              <div className="absolute -top-12 -left-12 w-48 h-48 bg-emerald-100 rounded-full blur-3xl opacity-40"></div>
              <div className="absolute -bottom-12 -right-12 w-48 h-48 bg-green-200 rounded-full blur-3xl opacity-40"></div>

              <div className="relative z-10 text-center">
                {/* 🎉 Celebration Header */}
                <div className="flex flex-col items-center mb-2">
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.1, type: "spring" }}
                    className="text-green-500 text-4xl mb-2"
                  >
                    <FaCheckCircle />
                  </motion.div>
                  <h3 className="text-xl font-bold text-gray-900">Final Price Received!</h3>
                  <p className="text-sm text-gray-600 mt-1">
                    You’ve unlocked your best price. Secure it before time runs out!
                  </p>
                </div>

                {/* 💰 Price Summary Card */}
                <div className="bg-gradient-to-r from-green-50 via-emerald-50 to-green-100 rounded-xl border border-green-200 p-4 mb-5 shadow-sm">

                  {/* CASE 1: SHOW ONLY FINAL PRICE WHEN NO SAVINGS */}
                 {/*  {(!rfqData.total_savings || rfqData.total_savings === 0) && (
                    <div className="flex flex-col items-center justify-center text-gray-800">
                      <span className="text-xs uppercase tracking-wide text-gray-600">Final Price</span>
                      <span className="text-lg font-bold text-gray-900 mt-1">
                        ₹{Number(rfqData.total).toLocaleString("en-IN")}
                      </span>
                    </div>
                  )} */}

                  {/* CASE 2: SHOW FINAL PRICE + SAVINGS SIDE BY SIDE */}
                  {rfqData.total_savings > 0 ? (
                    <div className="grid grid-cols-2 divide-x divide-green-200 text-gray-800">

                      {/* Final Amount */}
                      <div className="flex flex-col items-center justify-center">
                        <span className="text-xs uppercase tracking-wide text-gray-600">Final Price</span>
                        <span className="text-lg font-bold text-gray-900 mt-1">
                          ₹{Number(rfqData.total).toLocaleString("en-IN")}
                        </span>
                      </div>

                      {/* Saved */}
                      <div className="flex flex-col items-center justify-center">
                        <span className="text-xs uppercase tracking-wide text-gray-600 flex items-center gap-1">
                          You Saved <FaPiggyBank className="text-green-500 text-sm" />
                        </span>
                        <span className="text-lg font-bold text-green-700 mt-1">
                          ₹{Number(rfqData.total_savings).toLocaleString("en-IN")}
                        </span>
                      </div>

                    </div>
                  ):(
                  <div className="flex flex-col items-center justify-center text-gray-800">
                      <span className="text-xs uppercase tracking-wide text-gray-600">Final Price</span>
                      <span className="text-lg font-bold text-gray-900 mt-1">
                        ₹{Number(rfqData.total).toLocaleString("en-IN")}
                      </span>
                    </div>
                  )}

                </div>


                {/* ⏳ Countdown Section */}
                <div className="text-sm text-gray-700 mb-3 font-medium">
                  Complete your payment within{" "}
                  <span className="text-red-600 font-bold">
                    {formatCountdown(timer)}
                  </span>
                </div>

                {/* ⚠️ BuildCoin Warning */}
                <p className="text-xs text-gray-500 mb-5">
                  *If payment isn’t completed in time,{" "}
                  <span className="text-red-500 font-semibold">100 BuildCoins</span> will be charged.
                </p>

                {/* ✅ OK Button */}
                <button
                  onClick={handleCloseViewBestPricePoup}
                  className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white py-2.5 rounded-lg font-semibold text-sm transition-all shadow-md"
                >
                  OK
                </button>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      )}

      {swapAndSavePopup && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center px-4">
          <div className="bg-white w-full max-w-sm rounded-2xl shadow-2xl p-5 relative animate-fadeIn">

            {/* Header */}
            <h3 className="text-lg font-bold text-gray-900 text-center">
              Swap & Save!
            </h3>
            <p className="text-sm text-gray-500 text-center mt-1">
              Our supplier recommends a better option for you.
            </p>

            {/* Comparison Box */}
            <div className="mt-4 bg-gray-50 rounded-xl p-4 border border-gray-200">

              {/* Old Item */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gray-200 rounded-lg overflow-hidden">
                  <img
                    src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${prevItem?.item_image}`}
                    alt=""
                    className="object-contain w-full h-full"
                  />
                </div>

                <div className="flex-1">
                  <p className="text-xs text-gray-500 font-medium">Your Item</p>
                  <p className="text-sm font-semibold line-clamp-1">{prevItem?.item_name}</p>
                  <p className="text-xs text-gray-600">
                    ₹{Number(prevItem?.selling_price * prevItem?.quantity).toLocaleString("en-IN")}
                  </p>
                </div>
              </div>

              {/* Arrow */}
              <div className="w-full flex justify-center my-2">
                <span className="text-gray-400 text-xl">↓</span>
              </div>

              {/* New Suggested Item */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-lg overflow-hidden">
                  <img
                    src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${swapItem?.item_image}`}
                    alt=""
                    className="object-contain w-full h-full"
                  />
                </div>

                <div className="flex-1">
                  <p className="text-xs text-green-600 font-medium">
                    Recommended Alternative
                  </p>
                  <p className="text-sm font-semibold line-clamp-1">{swapItem?.item_name}</p>
                  <p className="text-xs text-green-700 font-bold">
                    ₹{Number(swapItem?.selling_price * prevItem?.quantity).toLocaleString("en-IN")}
                  </p>
                </div>
              </div>
            </div>

            {/* Savings Block */}
            {/* Calculate Savings */}


            {/* Show ONLY when savings is positive */}
            {savingsAmount > 0 && (
              <div className="mt-4 bg-green-50 border border-green-200 rounded-xl p-3 text-center">
                <p className="text-sm text-green-700 font-medium">
                  You save{" "}
                  <span className="font-bold">
                    ₹{Number(savingsAmount).toLocaleString("en-IN")}
                  </span>{" "}
                  with this swap!
                </p>
              </div>
            )}

            {/* Buttons */}
            <div className="mt-5 flex items-center gap-3">

              <button
                onClick={() => setSwapAndSavePopup(false)}
                className="flex-1 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium border border-gray-300 hover:bg-gray-200"
              >
                Keep Old Item
              </button>

              <button
                onClick={() => {
                  // Call your API or update code for swap here
                  console.log("Swapped!");
                  handleSwapAndSaveItem()
                  setSwapAndSavePopup(false);
                }}
                className="flex-1 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg font-semibold shadow hover:from-red-600 hover:to-red-700"
              >
                Swap & Save
              </button>

            </div>
          </div>
        </div>
      )}



    </div>
  );
}
